import { render } from "./miniSpinner.vue?vue&type=template&id=0bc78ab0&scoped=true&ts=true"
import script from "./miniSpinner.vue?vue&type=script&lang=ts"
export * from "./miniSpinner.vue?vue&type=script&lang=ts"

import "./miniSpinner.vue?vue&type=style&index=0&id=0bc78ab0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc78ab0"]])

export default __exports__